export default {
  messages: [],
  isLoading: false,
  toolStatus: null,
  streamingText: null,
  activeAction: null,
  error: null,
}
